import styled from 'styled-components'

export const WrapperUserPanel = styled.div.attrs(() => ({
  className: 'sidebar-user text-center'
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const TitleName = styled.h6.attrs(() => ({
  className: 'mt-3 f-14'
}))``

export const CurrentDock = styled.p.attrs(() => ({
  className: 'mt-1'
}))`
  width: 100%;
  font-weight: bold !important;
  font-size: 16px !important;
  overflow-wrap: break-word;
`

export const FCName = styled.p`
  width: 100%;
  overflow-wrap: break-word;
`

export const ImageIcon = styled.img.attrs(() => ({
  className: 'align-self-center img-60 rounded-circle lazyloaded'
}))`
  box-shadow: rgb(192 203 255 / 42%) 0px 0px 2px 1px;
`

export const WrapperButtons = styled.div.attrs(() => ({
  className: 'actions'
}))``

export const ActionButton = styled.button`
  background: none;
  border: 0;
  color: inherit;
  cursor: pointer;
  font: inherit;
  margin: 0 8px;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }

  svg {
    vertical-align: middle;
    margin-right: 4px;
  }
`
